(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ru-featured-ingredients"] && !Shopify.designMode) return;
  try {
    
  class IngredientsCarouselWithProducts extends SliderComponent {
    constructor() {
      super();

      try {
        this.slider = this.querySelector('[id^="Slider-"]');
        if (this.slider) {
          this.slider.scrollLeft = 0;
        }

        this._slides = Array.from(this.querySelectorAll('.featured-ingredients__slide'));
        this._infoBlocks = Array.from(this.querySelectorAll('.info-body__block'));
        this._addonBlocks = Array.from(this.querySelectorAll('.featured-ingredients__additional-info'));
        this._accordionBlocks = Array.from(this.querySelectorAll('.featured-ingredient__accordion-item'));

        this._titleEl = this.querySelector('.list-item__title');
        this._labelWrap = this.querySelector('.list-item__label-wrapper');
        this._labelEl = this.querySelector('.list-item__label');

        const sectionId = this.getAttribute('data-section-id');
        this._liveRegion = sectionId ? document.getElementById(`fi-live-${sectionId}`) : null;

        this._infoByIndex = new Map(this._infoBlocks.map(n => [String(n.dataset.infoIndex), n]));
        this._addonByIndex = new Map(this._addonBlocks.map(n => [String(n.dataset.additionalInfoIndex), n]));
        this._accByIndex = new Map(this._accordionBlocks.map(n => [String(n.dataset.accordionIndex), n]));
        this._slideByIndex = new Map(this._slides.map(n => [String(n.dataset.slideIndex), n]));

        this._active = { info: null, addon: null, acc: null, slide: null, index: "1" };

        this._pendingIndex = null;
        this._raf = null;
        this._lastSlideOffset = 0;

        this._firstSlideChange = true;

        const firstSlide = this._slides && this._slides.length > 0 ? this._slides[0] : null;
        const startIndex = firstSlide ? String(firstSlide.dataset.slideIndex) : "1";

        if (this._slides.length) {
          this._slides.forEach(slide => {
            slide.classList.remove('active-slide');
            slide.setAttribute('aria-current', 'false');
          });

          if (firstSlide) {
            firstSlide.classList.add('active-slide');
            firstSlide.setAttribute('aria-current', 'true');
          }
        }

        this._active.index = null;
        this._applyIndex(startIndex);

        this.addEventListener('slideChanged', this._onSlideChanged, { passive: true });

      } catch (error) {
        console.error('Error initializing Ingredients Carousel:', error);
      }
    }

    _onSlideChanged = (event) => {
      if (!event?.detail) return;

      const el = event.detail.currentElement;
      let idx;

      if (el && el.dataset.slideIndex) {
        idx = String(el.dataset.slideIndex);
      } else if (event.detail.currentPage) {
        idx = String(event.detail.currentPage);
      } else {
        idx = this._active.index;
      }

      this._pendingIndex = idx;

      if (this._raf) {
        cancelAnimationFrame(this._raf);
      }

      this._raf = requestAnimationFrame(() => {
        const indexToApply = this._pendingIndex;
        this._raf = null;
        this._applyIndex(indexToApply);
      });
    };

    _applyIndex(indexStr) {
      if (!indexStr || indexStr === this._active.index) return;

      const nextInfo = this._infoByIndex.get(indexStr);
      const nextAddon = this._addonByIndex.get(indexStr);
      const nextAcc = this._accByIndex.get(indexStr);
      const nextSlide = this._slideByIndex.get(indexStr) || this._slides[Number(indexStr) - 1];

      this._infoBlocks.forEach(n => { if (n !== nextInfo) this._setHidden(n, true); });
      this._addonBlocks.forEach(n => { if (n !== nextAddon) this._setHidden(n, true); });
      this._accordionBlocks.forEach(n => { if (n !== nextAcc) this._setHidden(n, true); });

      if (nextSlide && this._titleEl) {
        const title = nextSlide.dataset.title || '';
        const label = nextSlide.dataset.label || '';

        this._titleEl.textContent = title;

        if (this._liveRegion) {
          this._liveRegion.textContent = title;
        }

        if (this._labelEl && this._labelWrap) {
          if (label) {
            this._labelWrap.hidden = false;
            this._labelEl.querySelector('span').textContent = label;
          } else {
            this._labelWrap.hidden = true;
            this._labelEl.classList.add('hidden');
          }
        }
      }

      this._setHidden(this._active.info, true);
      this._setHidden(nextInfo, false);

      this._setHidden(this._active.addon, true);
      this._setHidden(nextAddon, false);

      this._setHidden(this._active.acc, true);
      this._setHidden(nextAcc, false);

      if (this._active.slide) {
        this._active.slide.classList.remove('active-slide');
        this._active.slide.setAttribute('aria-current', 'false');
      }

      if (nextSlide) {
        nextSlide.classList.add('active-slide');
        nextSlide.setAttribute('aria-current', 'true');
      }

      this._active = {
        info: nextInfo || null,
        addon: nextAddon || null,
        acc: nextAcc || null,
        slide: nextSlide || null,
        index: indexStr
      };
    }

    _setHidden(node, shouldHide) {
      if (!node) return;

      if (shouldHide) {
        if (!node.hidden) node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
      } else {
        if (node.hidden) node.hidden = false;
        node.removeAttribute('aria-hidden');
      }
    }

    isSlideVisible(element, offset = 0) {
      if (!this.sliderItemsToShow || !this.sliderItemsToShow.length) {
        return super.isSlideVisible(element, offset);
      }

      const lastVisible = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];

      if (lastVisible) {
        if (this._lastSlideOffset === 0) {
          const mr = window.getComputedStyle(lastVisible).marginRight;
          this._lastSlideOffset = parseInt(mr, 10) || 0;
        }

        if (this._lastSlideOffset > 0) {
          offset = this._lastSlideOffset;
        }
      }

      return super.isSlideVisible(element, offset);
    }
  }

  try {
    customElements.define('ingredients-carousel-with-products', IngredientsCarouselWithProducts);
  } catch (error) {
    console.error('Error registering Ingredients Carousel component:', error);
  }

  } catch(e) { console.error(e); }
})();
})();
